document.addEventListener('alpine:init', () => {
    /**
     * Set css var x and y for an element's rendered position relative to the document
     */
    Alpine.directive('page-pos', ($el) => {
        const getPagePos = (node) => {
            let x = 0, y = 0
            while (node) {
                x += node.offsetLeft
                y += node.offsetTop
                node = node.offsetParent
            }
            return { x, y }
        }

        const setY = () => {
            $el.style.setProperty('--x', `${getPagePos($el).x}px`)
            $el.style.setProperty('--y', `${getPagePos($el).y}px`)
        }

        // wait for Alpine render
        queueMicrotask(setY)

        window.addEventListener('resize', setY)

        return () => {
            window.removeEventListener('resize', setY)
        }
    })
})
